export const HERBICIDE_PRODUCTIVITY_PARAMETER_GROUP_NAME = 'Herbicida';
export const TREATMENT_PRODUCTIVITY_PARAMETER_GROUP_NAME = 'Tratamiento';
